const awsconfig = {
  aws_project_region: "ap-northeast-1",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_Y3DGOe8py",
  aws_user_pools_web_client_id: "2hvseeafv8kog2511aoknrhii0",
  oauth: {},
  aws_appsync_graphqlEndpoint: "",
  aws_appsync_region: "ap-northeast-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export default awsconfig;